<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__content">
        <div class="footer__logo">
          Arynae Agency
        </div>
        <div class="footer__links">
          <div class="footer__column">
            <h3 class="footer__title">Services</h3>
            <ul class="footer__list">
              <!-- Utilisation d'un attribut computé to pour le chemin localisé -->
              <li><router-link :to="localizeRoute('/saas')">SaaS</router-link></li>
              <li><router-link :to="localizeRoute('/nocode')">No Code</router-link></li>
              <li><router-link :to="localizeRoute('/chatbot')">Chatbot</router-link></li>
              <li><router-link :to="localizeRoute('/seo')">SEO</router-link></li>
              <li><router-link :to="localizeRoute('/datascience')">Data Science</router-link></li>
            </ul>
          </div>

          <!-- Liens externes - pas besoin de localisation -->
          <div class="footer__column">
            <h3 class="footer__title">Ressources</h3>
            <ul class="footer__list">
              <li><a href="https://iaagence.fr/" target="_blank">Agence IA</a></li>
              <li><a href="https://www.meetingtranscript.fr/" target="_blank">Meeting Transcript</a></li>
              <li><a href="https://www.web-passion.fr/" target="_blank">Web Passion</a></li>
              <li><a href="https://www.graine-digitale.fr/" target="_blank">Graine Digitale</a></li>
            </ul>
          </div>

          <div class="footer__column">
            <h3 class="footer__title">Entreprise</h3>
            <ul class="footer__list">
              <li v-for="(link, index) in enterpriseLinks" :key="index">
                <span class="fake-link" @click="navigateTo(link.path)">{{ link.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <p>&copy; {{ new Date().getFullYear() }} Arynae LLC. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TheFooter',
  data() {
    return {
      enterpriseLinks: [
        { path: 'p1', text: 'Contact' },
        { path: 'p2', text: 'Privacy Policy /\nTerms of use' }
      ]
    }
  },
  computed: {
    ...mapState(['services']),
    
    // Ajouter cette propriété pour détecter la langue actuelle
    currentLocale() {
      return this.$route.meta?.locale || 'fr';
    }
  },
  methods: {
    // Méthode pour générer des chemins localisés
    localizeRoute(path) {
      if (this.currentLocale === 'en' && !path.startsWith('/en')) {
        return `/en${path}`;
      }
      return path;
    },
    
    // Mettre à jour la méthode de navigation pour les liens obfusqués
    navigateTo(code) {
      const routes = {
        'p1': '/contact',
        'p2': '/mentions-legales'
      };
      
      // Localiser le chemin si nécessaire
      let path = routes[code] || code;
      path = this.localizeRoute(path);
      
      this.$router.push(path);
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.footer {
  background-color: $dark-text;
  color: $white;
  padding: $spacing-xl 0 $spacing-md;
  margin-top: $spacing-xl;
  
  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing-lg;
    
    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      justify-content: space-between;
    }
  }
  
  &__logo {
    font-size: 24px;
    font-weight: bold;
  }
  
  &__links {
  display: flex;
  flex-wrap: wrap;
  gap: $spacing-lg;
  
  .footer__column {
    flex: 1;
    min-width: 200px;
  }
}
  
  &__title {
    font-size: 18px;
    margin-bottom: $spacing-md;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 0;
      width: 40px;
      height: 2px;
      background: $accent-gradient;
    }
  }
  
  &__list {
    list-style: none;
    
    li {
      margin-bottom: $spacing-xs;
      
      a {
        opacity: 0.8;
        transition: opacity 0.2s;
        
        &:hover {
          opacity: 1;
        }
      }
    }
  }
  
  &__address {
    font-style: normal;
    opacity: 0.8;
    
    p {
      margin-bottom: $spacing-xs;
    }
  }
  
  &__bottom {
    margin-top: $spacing-xl;
    padding-top: $spacing-md;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    text-align: center;
    font-size: 14px;
    opacity: 0.6;
  }
}

//Style obfuscation des liens
.fake-link {
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
  white-space: pre-line;
  
  &:hover {
    opacity: 1;
  }
}
</style>